import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppShell from './components/Layout/AppShell';

// Pages
import LoginPage         from './pages/Login/LoginPage';
import DashboardPage     from './pages/Dashboard/DashboardPage';
import AvailabilityPage  from './pages/Availability/AvailabilityPage';
import SchedulePage      from './pages/Schedule/SchedulePage';
import SwapsPage         from './pages/Swaps/SwapsPage';
import AdminPage         from './pages/Admin/AdminPage';

const SSL_AND_ABOVE = ['SSL', 'ADMIN', 'UPPER_ADMIN'];

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<LoginPage />} />

          {/* Authenticated — wrapped in the AppShell layout */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AppShell />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard"    element={<DashboardPage />} />

              {/* SL + above */}
              <Route path="/availability" element={<AvailabilityPage />} />
              <Route path="/schedule"     element={<SchedulePage />} />
              <Route path="/swaps"        element={<SwapsPage />} />

              {/* SSL + above */}
              <Route element={<ProtectedRoute roles={SSL_AND_ABOVE} />}>
                <Route path="/schedule/manage" element={<SchedulePage manage />} />
                <Route path="/swaps/approvals" element={<SwapsPage approvals />} />
              </Route>

              {/* SSL + above can reach /admin (Periods + Test Harness).
                  AdminPage filters tabs/panels by role; Users / Semesters /
                  District Setup are still admin-only at the panel level. */}
              <Route element={<ProtectedRoute roles={SSL_AND_ABOVE} />}>
                <Route path="/admin/*" element={<AdminPage />} />
              </Route>
            </Route>
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
